import { useListMedia } from '@reelplicate/api-client/media';

/** The first few images of these collections, to preview caption styles on. */
export function useSlotImages(
  workspaceId: string,
  collectionIds: (string | undefined)[],
) {
  const ids = new Set(collectionIds.filter(Boolean));
  const { data } = useListMedia(workspaceId, {
    query: { enabled: Boolean(workspaceId) && ids.size > 0, throwOnError: false },
  });
  return (data?.items ?? [])
    .filter((a) => a.kind === 'IMAGE' && a.collectionIds.some((id) => ids.has(id)))
    .flatMap((a) => a.thumbnailUrl ?? a.fileUrl ?? [])
    .slice(0, 4);
}
